import React, { useRef } from 'react';
import { useGridEditorPresenter } from './GridEditorPresenter';
import { GridEditorView } from './GridEditorView';

export const GridEditor: React.FC = () => {
  const svgRef = useRef<SVGSVGElement>(null);
  const { state, actions, lightTypes } = useGridEditorPresenter(svgRef);

  return (
    <GridEditorView
      state={state}
      actions={actions}
      lightTypes={lightTypes}
      svgRef={svgRef}
    />
  );
};
